module.exports = __webpack_public_path__ + "img/product-1.366d3501.png";